import { useLogin } from "@/app/utils/auth";
import { environment } from "@/environment";
import { ExclamationCircleIcon } from "@heroicons/react/16/solid";
import { SupportedLanguage } from "@onetutor/shared/type";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router";
import Typewriter from "typewriter-effect";
import i18n from "../../../i18n";
import { DynamicLogo } from "../../components/header/DynamicLogo";
import Header from "../../components/header/Header";

function LoginPage() {
  const auth = useAuth();
  const login = useLogin({ isGuestLogin: false });
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate("/");
    }
  }, [auth.isAuthenticated, navigate]);

  const { t } = useTranslation(["loginPage"]);

  return (
    <Header showFooter={true}>
      <div className="flex min-h-[calc(100vh-200px)] flex-col items-center justify-center md:flex-row">
        <div className="flex justify-center">
          <div className="mx-sm w-72 sm:w-[400px]">
            <h1 className="mb-6 flex flex-col gap-2 font-bold text-3xl sm:flex-row sm:items-center">
              {t("welcomeText")}
              <DynamicLogo />
            </h1>
            <div className="h-20">
              <Typewriter
                onInit={(typewriter) => {
                  typewriter
                    .pauseFor(1000)
                    .typeString(t("typewriterPart1"))
                    .pauseFor(1000)
                    .deleteChars(
                      i18n.language === SupportedLanguage.DE ? 19 : 24,
                    )
                    .typeString(t("typewriterPart2"))
                    .start();
                }}
                options={{
                  delay: 42,
                  deleteSpeed: 35,
                  skipAddStyles: true,
                  wrapperClassName: "font-mono text-xl text-base-content",
                  cursorClassName: "text-error font-bold animate-pulse",
                }}
              />
            </div>
            <button
              type="button"
              className="btn btn-primary mt-4 w-full"
              onClick={login}
            >
              {t("login")}
            </button>
            <div className="mt-md rounded-lg bg-neutral p-4">
              <div className="flex flex-row">
                <div>
                  <ExclamationCircleIcon className="mr-2 h-5 w-5" />
                </div>
                <span className="font-bold">{t("infoBeta")}</span>
              </div>
              <div className="mt-4 text-center">
                {environment.isOneTutorDomain ? t("visitOur") : t("poweredBy")}{" "}
                <a
                  href="https://onetutor.ai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-bold text-primary hover:underline"
                >
                  {environment.isOneTutorDomain ? t("productPage") : "OneTutor"}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Header>
  );
}

export default LoginPage;
